<template>

  <b-navbar id="agNavbar" :key="reload">
        <div v-if="displayBackButton" :style="{'width': '100%'}">
      <b-button id="agNavbar-backButton" class="agNavbarItem agImageButton" @click="agNavbarItem_clicked('workflows')">
        <fa icon="chevron-left"/>
        Back
      </b-button>
      <span ref="title" id="agNavbar-title">{{title}}</span>
    </div>
    <div v-else>
      <b-navbar-brand  
        id="agNavbarLogo" 
        class="agNavbarItem" 
        href=".">
        <div><b>ActiveG</b> Nash&trade;</div>
        <div id="agNavbarLogo-version">{{version}}</div>
      </b-navbar-brand>
      <b-nav v-if="displayTabs" id="agNavbarLeftNav" pills>
        <b-nav-item class="agNavbarItem" @click="agNavbarItem_clicked('workflows')" :active="page=='workflows'"><fa icon="project-diagram"/><span>Workflows</span></b-nav-item>
        <b-nav-item class="agNavbarItem" @click="agNavbarItem_clicked('connections')" :active="page=='connections'"><fa icon="plug"/><span>Connections</span></b-nav-item>
        <b-nav-item class="agNavbarItem" @click="agNavbarItem_clicked('logs')" :active="page=='logs'"><fa icon="clipboard-list"/><span>Logs</span></b-nav-item>
      </b-nav>
    </div>
    <b-navbar-nav id="agNavbarRightNav" class="ml-auto">
      <b-nav-item-dropdown v-if="user" id="agNavbarUserButton" class="agImageButton agDropdown agNavbarItem" :text="user.name" right>
        <b-dropdown-item href="#" @click="agNavbarItem_clicked('workspaces')"><fa icon="briefcase"/>Workspaces</b-dropdown-item>
        <b-dropdown-item v-if="user.role=='admin'" href="#" @click="agNavbarItem_clicked('usersGroups')"><fa icon="users"/>Users &amp; groups</b-dropdown-item>
        <b-dropdown-item href="#" @click="passwordButton_clicked"><fa icon="key"/>Change password</b-dropdown-item>
        <b-dropdown-item href="#" @click="licenseButton_clicked"><fa icon="id-card"/>License</b-dropdown-item>
        <b-dropdown-item href="#" @click="helpButton_clicked"><fa icon="question-circle"/>Help</b-dropdown-item>
        <b-dropdown-item href="#" @click="logoutButton_clicked"><fa icon="sign-out-alt"/>Logout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>

</template>





<script>

  // components
  
  // modules
  import {EventBus} from "src/eventBus";

  export default
  {
      name: "ag-navbar",
      props: {
        user: Object,
        page: String
      },
      data()
      {
        return {
          reload: 0,
          title: "",
          backButtonPages: ["workflowEditor", "usersGroups", "workspaces"],
          tabsPages: ["workflows", "connections", "logs"],
        };
      },

      computed:
      {
        version() {
          return this.$store.state.version;
        },

        displayBackButton() {
          return this.backButtonPages.indexOf(this.page) > -1;
        },

        displayTabs()
        {
            return this.tabsPages.indexOf(this.page) > -1;
        },
      },

      watch: {

      },

      created() {
         EventBus.$on("setNavbarTitle", params => {
            this.setTitle(params.title);
         });
      },

      methods:
      {
          // UI Events

          agNavbarItem_clicked(page)
          {
            if(page == "workspaces") {
              var options = {
                title: "Workspaces"
              }
              this.$store.dispatch("wsStore/setWorkspaces");
            }
            else if(page == "usersGroups") {
              var options = {
                title: "Users & Groups"
              }
              this.$store.dispatch("wsStore/setWorkspaces");
            }
            this.$emit("setPage", page, options);
          },

          passwordButton_clicked() {
            this.$emit("changePassword");
          },

          licenseButton_clicked() {
             this.$emit("showLicense");
          },

          helpButton_clicked() {
            var url = "https://support.activeg.com/nash";
            window.open(url, '_blank');
          },

          logoutButton_clicked() {
            this.$store.dispatch("userStore/logout");
          },

          setTitle(title) {
            this.title = title;

              // dynamically adjust title position
            setTimeout(() => {
              var width = this.$refs.title.clientWidth;
              this.$refs.title.style.marginLeft = -width/2.0 + "px";
              this.$refs.title.style.opacity = 1.0;
            }, 250);
          }
      }
  };

</script>






<style lang="css">

  #agNavbar
  {
    position: fixed;
    height: 60px;
    width: 100%;
    top: 0px;
    z-index: 1000;
    background: #4A797C;
    color: #FFFFFF;
  }

  #agNavbarLogo
  {
    float: left;
    margin: 0px 25px 0px 10px;
    font-size: 24px;
  }

  #agNavbarLogo-version {
    text-align: left;
    font-size: 14px;
    min-height: 21px;
    margin-top: -5px;
  } 

  .agNavbarItem
  {
    margin-top: 10px;
    margin-left: 15px;
    color: #FFFFFF !important;
    font-size: 18px;
  }

  .agNavbarItem:hover
  {
    opacity: 0.5;
  }
  
  .agNavbarItem span
  {
    color: #FFFFFF;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.75);
  }

  .agNavbarItem svg
  {
    color: #FFFFFF;
    margin-right: 7.5px;
  }

  #agNavbarUserButton {
    margin-top: -2.5px;
  }

  /* caret on user dropdown */
  .agNavbarItem a::after
  {
    border-top-color: #FFFFFF;
    border-bottom-color: #FFFFFF;
  }

  #agNavbarUserButton:hover
  {
    opacity: 1.0;
  }

  #agNavbarUserButton >>> a:hover
  {
    opacity: 0.5;
  }

  #agNavbarUserButton >>> a.nav-link
  {
    color: #FFFFFF !important;
  }

  #agNavbar-backButton
  {
      float: left;
      margin-top: 2.5px;
  }

  #agNavbar-backButton:hover
  {
      color: #FFFFFF !important;
  }

  #agNavbar-title
  { 
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -16.5px;
    font-weight: bold;
    font-size: 22px;
    opacity: 0.0;
  }


</style>



// WEBPACK FOOTER //
// src/components/ui/Navbar.vue